'use strict';

export enum LoadingOverlayStates {
  Loading = 'LOADING',
  Idle = 'IDLE',
}
